import { useCallback } from "react";

import { BasketItemPrice } from "@is/types";

import { useBasket } from "./useBasket";
import { useBasketUpdate } from "./useBasketUpdate";

export type BasketItemRequest = {
  ean: string;
  productId: string;
  price: BasketItemPrice;
  quantity: number;
  variantId?: string;
};

type Basket = {
  items: BasketItemRequest[];
};

export const useManageBasket = () => {
  const { basketItems, totalPrice, totalItems } = useBasket({
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
  });

  const [{ isPending, error }, updateBasket] = useBasketUpdate();

  const handleUpdateBasket = useCallback(
    async ({ items }: Basket) => {
      await updateBasket({ items, basketItems });
    },
    [basketItems, updateBasket]
  );

  return {
    basketItems,
    handleUpdateBasket,
    isPending,
    error,
    totalPrice,
    totalItems,
    updateBasket,
  };
};
